import server from './server'

export const fetchZohoLead = (zohoLeadId) => {
  return server.get(`/zoho/leads/${zohoLeadId}`)
}
